<template>
  <section class="py-20">
    <div class="container mx-auto">
      <div v-reveal class="mb-12 text-center">
        <h2 class="mb-4 text-3xl font-bold text-ternary-dark dark:text-primary-light sm:text-4xl">
          How we <span class="bg-gradient-to-r from-accent to-gradient-end bg-clip-text text-transparent">work</span>
        </h2>
      </div>
      <ol class="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        <li v-for="(step, index) in steps" :key="step.title" v-reveal="index * 100" class="rounded-2xl border border-gray-200/60 p-6 dark:border-white/10">
          <span class="mb-4 flex size-10 items-center justify-center rounded-full bg-accent/10 font-bold text-accent">{{ index + 1 }}</span>
          <h3 class="mb-2 text-lg font-bold text-ternary-dark dark:text-ternary-light">
            {{ step.title }}
          </h3>
          <p class="text-sm leading-relaxed text-gray-600 dark:text-gray-400">
            {{ step.text }}
          </p>
        </li>
      </ol>
    </div>
  </section>
</template>

<script setup lang="ts">
const steps = [
  { title: 'Discover', text: 'We learn your goals, users and constraints, then agree on scope, timeline and budget.' },
  { title: 'Design', text: 'Wireframes and UI that are quick to review, so decisions happen before code is written.' },
  { title: 'Build', text: 'Iterative delivery with regular demos, clean code, tests and CI from the start.' },
  { title: 'Launch & support', text: 'Deployment, store publishing, monitoring and ongoing maintenance after release.' },
]
</script>
